import { FpCorrelationTabs } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/enums/fp-correlation-tabs.enum';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';
import { IFpCorrelationTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-tab-connect-service';

export enum FpCorrelationManagerActionType {
  Init = 'Init',
  SelectedDataUpdated = 'SelectedDataUpdated',
  ChangeTab = 'ChangeTab',
  GlobalDataLoadingStateChanged = 'GlobalDataLoadingStateChanged',
}

export interface FpCorrelationManagerActionInit {
  type: FpCorrelationManagerActionType.Init;
  popupId: string;
  activeTab: FpCorrelationTabs;
  selectedData: IFpCorrelationData | null;
}

export interface FpCorrelationManagerActionGetSelectedDataUpdated {
  type: FpCorrelationManagerActionType.SelectedDataUpdated;
  selectedData: IFpCorrelationData | null;
}

export interface FpCorrelationManagerActionChangeTab {
  type: FpCorrelationManagerActionType.ChangeTab;
  activeTabConnectService: IFpCorrelationTabConnectService | null;
}

export interface FpCorrelationManagerActionGlobalDataLoadingStateChanged {
  type: FpCorrelationManagerActionType.GlobalDataLoadingStateChanged;
  loading: boolean;
}

export type FpCorrelationManagerActions =
  | FpCorrelationManagerActionInit
  | FpCorrelationManagerActionGlobalDataLoadingStateChanged
  | FpCorrelationManagerActionGetSelectedDataUpdated
  | FpCorrelationManagerActionChangeTab;
